module.exports = __webpack_public_path__ + "static/img/sy.c3812b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Home/sy.png
// module id = F5vN
// module chunks = 2